import { z } from "zod";

/**
 * Zod schema for the CreateOrganizationModal form.
 * Mirrors backend CreateOrganizationCommandValidator:
 * - Name: NotEmpty
 * - OrganizationSecret: NotEmpty
 * - IntactId: NotEmpty
 */
export const createOrganizationSchema = z.object({
  name: z.string().min(1, "Name is required"),
  intactId: z.string().min(1, "Intact ID is required"),
  secret: z.string().min(1, "Secret is required"),
});
